import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import join from 'join-array';
import { workflowTagDisplayName } from './DisplayNames';
import { publicationWorkflowTags } from './SelectableOptions';

export const getContentWorkflowTags = (workflow: ContentWorkflow) => {
  const draftWorkflowTags = workflow.draftWorkflowTags || [];
  let lastPublicationWorkflowTags = workflow.lastPublicationWorkflowTags || [];
  // @ts-expect-error TS2322 - strict migration
  lastPublicationWorkflowTags = [...lastPublicationWorkflowTags].filter((workflowTag) =>
    publicationWorkflowTags.includes(workflowTag),
  );
  return new Set([...draftWorkflowTags, ...lastPublicationWorkflowTags]);
};

export const getContentWorkflowTagNames = (workflow: ContentWorkflow): string => {
  const tags = [...getContentWorkflowTags(workflow)];
  return join({
    array: tags,
    separator: ', ',
    // @ts-expect-error TS7006 - strict migration
    each: (tag) => workflowTagDisplayName.get(tag),
  });
};
